import { BetslipPick } from '../../core/picks/betslip-pick';
import { ISingleBetState } from '../single-bet/state';
import { ISystemBetState } from '../system-bet/state';

export function orderPicksByTypeState(pickList: BetslipPick[], typeState: ISingleBetState | ISystemBetState) {
    return [...pickList]
        .filter((pick) => typeState.picks[pick.id.toString()])
        .sort((a, b) => typeState.picks[a.id.toString()].order - typeState.picks[b.id.toString()].order);
}

export function populateOrder<T extends Record<string, { order: number }>>(picks: T): T {
    if (!picks) {
        return picks;
    }

    return Object.entries(picks).reduce(
        (acc, curr, i) => {
            acc[curr[0]] = Object.assign({ order: i }, curr[1]);

            return acc;
        },
        {} as Record<string, { order: number }>,
    ) as T;
}
